import Vue from 'vue'

const self = Vue.prototype

export default {

    getHistory(tracking, captchaToken) {
        return new Promise((resolve, reject) => {
            self.axios.post(self.$apiRouter.tracking, {tracking: tracking, "g-recaptcha-token": captchaToken})
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getHistoryForUser(tracking) {
        return new Promise((resolve, reject) => {
            self.axios.post(self.$apiRouter.trackingUser, {tracking: tracking})
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

}
